export const SETTINGS = {
  tileView: 'tileView',
  enableTealium: 'enableTealium',
  enableHubTracing: 'enableHubTracing',
  enableSentry: 'enableSentry',
  enableSentryPerformance: 'enableSentryPerformance',
  enableSentrySession: 'enableSentrySession',
  enableDebugLog: 'enableDebugLog',
  enableTrackingLog: 'enableTrackingLog',
  enableGkAir: 'enableGkAir',
  gkAirUrl: 'gkAirUrl'
} as const;

export type SettingName = (typeof SETTINGS)[keyof typeof SETTINGS];
